$(() => $('.restricted-begin-date, .restricted-end-date').on('change', '#begin_date, #end_date', function(event) {
  const beginDate = new Date($(this).val());
  const endDate = new Date($('#end_date').val());
  const dateRange = $('.restricted-begin-date').data('date-range');
  if (((endDate - beginDate) / (1000 * 60 * 60 * 24)) > dateRange) {
    return $('.date-range-error-message').html('Warning: Threshold begin and end dates are more than ' + dateRange + ' days apart');
  } else {
    return $('.date-range-error-message').html('');
  }
}));